import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation(); // Detectăm schimbarea de rută

    useEffect(() => {
        window.scrollTo(0, 0); // Facem scroll în partea de sus
    }, [pathname]); // Acționăm la schimbarea rutei

    return null;
};

export default ScrollToTop;
